import React, { useState, useCallback } from 'react';
import Slider, { SliderTooltip } from 'rc-slider';
import PropTypes from 'prop-types';

import { prices } from '../utils/contentProvider';

export const Pricing = ({ setStep, step, openModalToggle }) => {
  const { Handle } = Slider;

  const handle = (props) => {
    const { value, marks, dragging, index, ...restProps } = props;
    function setTooltip() {
      setTimeout(() => {
        SliderTooltip.visible = true;
      }, 1000);
    }

    const jobMarker = prices.jobs.slice();
    if (typeof jobMarker[jobMarker.length - 1] === 'number') {
      jobMarker[jobMarker.length - 1] += '+';
    }
    return (
      <SliderTooltip
        prefixCls="rc-slider-tooltip"
        overlay={`${jobMarker[value]} ${
          tabActive === 0 ? 'posting/month' : 'job posting'
        }`}
        visible={setTooltip}
        placement="top"
        key={index}>
        <Handle value={value} {...restProps} />
      </SliderTooltip>
    );
  };

  const [tabActive, setTabActive] = useState(1);

  const toggleTabAccordion = useCallback(
    (id) => () => {
      setTabActive(() => id);
    },
    [],
  );

  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <span className="big-gradient-circle gradient-anim red-gradient" />
        <span className="big-gradient-circle gradient-anim delay-1 " />
        <span className="big-gradient-circle gradient-anim delay-2 green-gradient" />
        <div className="pricing-head">
          <h5 className="yellow-heading text-center">Pricing &#38; Plans</h5>
          <h3 className="text-center">Choose Plan &#38; Join Waitlist</h3>
          <p className="text-center">
            Let us help you to find the best talent for your company, whether
            it’s 1 or 1000 job openings. Get early access to ClipHire Recruit to
            use our features.
          </p>
        </div>
        <div className="pricing-main">
          <div className="tab-list">
            <div className="flex-row no-margin">
              <button
                type="button"
                className={`tab ${tabActive === 1 ? ' active' : ''}`}
                onClick={toggleTabAccordion(1)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 176 41">
                  <path
                    fill="#fbfbfb"
                    fillRule="evenodd"
                    stroke="#f2f2f2"
                    strokeWidth="2"
                    d="M26.9 1H175v39H2L19.8 5.4C21.1 2.7 23.9 1 26.9 1z"
                    clipRule="evenodd"
                  />
                </svg>
                <p>Monthly</p>
              </button>
              <button
                type="button"
                className={`tab ${tabActive === 0 ? ' active' : ''}`}
                onClick={toggleTabAccordion(0)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0"
                  y="0"
                  viewBox="0 0 176 41">
                  <path
                    fill="#fbfbfb"
                    fillRule="evenodd"
                    stroke="#f2f2f2"
                    strokeWidth="2"
                    d="M26.9 1H175v39H2L19.8 5.4C21.1 2.7 23.9 1 26.9 1z"
                    clipRule="evenodd"
                  />
                </svg>
                <p>Yearly</p>
              </button>
            </div>
          </div>
          <div className="tab-content">
            <div className="flex-row no-margin">
              <div className="col-7 col">
                <div className="plan-number">
                  <h5>Select number of jobs</h5>
                  <div className="custom-rangeslider">
                    <Slider
                      min={0}
                      max={4}
                      defaultValue={0}
                      onChange={(value) => setStep(value)}
                      marks={{
                        0: `${prices.jobs[0]}`,
                        1: `${prices.jobs[1]}`,
                        2: `${prices.jobs[2]}`,
                        3: `${prices.jobs[3]}`,
                        4: `${prices.jobs[4]}+`,
                      }}
                      step={null}
                      handle={handle}
                    />
                  </div>
                  <p>
                    Join the waitlist to get access to the finest talent out
                    there - No Credit Card Required{' '}
                    <span className="yellow">*</span>
                  </p>
                  <div className="flex-row no-margin align-items-center">
                    <h4 className="striked-text">
                      &#36;{' '}
                      {`${
                        tabActive === 0
                          ? Math.round((prices.yearlyPrices[step] * 100) / 80)
                          : Math.round((prices.monthlyPrices[step] * 100) / 80)
                      }${step === prices.yearlyPrices.length - 1 ? '+' : ''}`}
                    </h4>
                    <h5 className="yellow-heading">
                      Save 20&#37; , pre launch offer
                    </h5>
                  </div>
                  <h2 className="price heading">
                    &#36;{' '}
                    {`${
                      tabActive === 0
                        ? prices.yearlyPrices[step]
                        : prices.monthlyPrices[step]
                    }${step === prices.yearlyPrices.length - 1 ? '+' : ''}`}
                    {/* &#36;{`${tabActive === 0 ? ' 900' : ' 99'}`} */}
                    <span>{`${tabActive === 0 ? ' /year' : ' /mo'}`}</span>
                  </h2>
                  <button
                    type="button"
                    onClick={openModalToggle}
                    className="button button-green">
                    Join Waitlist
                  </button>
                </div>
              </div>
              <div className="col-5 col">
                <div className="plan-details">
                  <h5>This plan includes</h5>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Post Jobs</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Find Talented Job Seekers</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Unlimited Team Members</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>30-second job description video</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Live chat support</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Portal to view all applicants</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Filter approved applicants based on qualifications</p>
                  </div>
                  <div className="flex-row align-items-center">
                    <img src="/img/check-violet.svg" alt="" />
                    <p>Assign job postings to team members</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-branding">
          <div className="flex-row no-margin">
            <div className="col-6 col" style={{ margin: 'auto' }}>
              <div className="custom-branding-image">
                <img src="/img/custom-branding.png" alt="" />
              </div>
            </div>
            <div className="col-6 col">
              <div className="custom-branding-content">
                <h5 className="yellow-heading">COMING SOON</h5>
                <h3>Employer Branding Page</h3>
                <p>
                  Create your profile, add your logo, adjust color codes, host
                  on your URL. Make it all yours.
                </p>
                <h2 className="price stars">
                  &#36;{`${tabActive === 0 ? ' 4300' : ' 399'}`}
                  <span>{`${tabActive === 0 ? ' /year' : ' /mo'}`}</span>
                </h2>
                <button
                  type="button"
                  onClick={openModalToggle}
                  className="sign-up button button-green">
                  Join Waitlist
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Pricing.propTypes = {
  value: PropTypes.number,
  marks: PropTypes.object,
  dragging: PropTypes.node,
  index: PropTypes.number,
  setStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  openModalToggle: PropTypes.func.isRequired,
};

export default Pricing;
